import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import logoFooter from '../assets/logo_footer.png';

const Footer = () => {
  return (
    <footer className="bg-green text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* GRILLE PRINCIPALE */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 h-full items-stretch">
          
          {/* --- COLONNE 1 : Brand & Logo --- */}
          <div className="flex flex-col h-full items-start">
            
            {/* 1. IMAGE : LOGIQUE INVERSÉE */}
            {/* Au lieu de w-56, on fixe la HAUTEUR (h-32) pour ne pas pousser le texte */}
            {/* object-left assure que le logo reste calé à gauche */}
            <img 
              src={logoFooter} 
              alt="Logo Soul Kitchen" 
              className="h-28 md:h-36 w-auto object-contain object-left mb-4"
            />

            {/* 2. TEXTE EN BAS */}
            {/* mt-auto : Pousse en bas */}
            {/* pb-1 : Petite astuce pour remonter le texte de ~4px et l'aligner pile avec l'adresse */}
            <div className="mt-auto w-full pb-1">
              <p className="text-gray-300 mb-0 leading-snug" style={{ color: '#F9F6F0' }}>
                Cuisine locale, végétalienne et de saison pour une meilleure santé et un monde plus durable.
              </p>
            </div>
          </div>

          {/* --- COLONNE 2 : Navigation --- */}
          <div className="flex flex-col h-full">
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-[#F9F6F0] hover:text-[#3E332E] transition-colors">Accueil</Link></li>
              <li><Link to="/services" className="text-[#F9F6F0] hover:text-[#3E332E] transition-colors">Services & Réalisations</Link></li>
              <li><Link to="/equipe" className="text-[#F9F6F0] hover:text-[#3E332E] transition-colors">Notre Équipe</Link></li>
              <li><Link to="/contact" className="text-[#F9F6F0] hover:text-[#3E332E] transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* --- COLONNE 3 : Contact Info --- */}
          <div className="flex flex-col h-full">
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            
            <ul className="space-y-3 flex-1 flex flex-col">
              <li className="flex items-start">
                <Mail className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0 text-[#F9F6F0]" />
                <a href="mailto:contact@soulkitchenandco.fr" className="text-[#F9F6F0] hover:text-[#3E332E] transition-colors">contact@soulkitchenandco.fr</a>
              </li>
              
              <li className="flex items-start">
                <Phone className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0 text-[#F9F6F0]" />
                <a href="tel:+33626291294" className="text-[#F9F6F0] hover:text-[#3E332E] transition-colors">+33 6 26 29 12 94</a>
              </li>

              {/* L'ADRESSE : Reste la référence basse */}
              <li className="flex items-start mt-auto leading-snug">
                <MapPin className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0 text-[#F9F6F0]" />
                <a 
                  href="https://www.google.com/maps?q=2646+route+de+Peyraube+30770+Arrigas" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#F9F6F0] hover:text-[#3E332E] transition-colors text-left"
                >
                  2646 Route de Peyraube, 30770 Arrigas
                </a>
              </li>
            </ul>
          </div>

        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center" style={{ color: '#3E332E' }}>
          <p>© {new Date().getFullYear()} Soul'Kitchen and Co. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;